import * as React from 'react';
import Box from '../../../parts/Box';
import {
    IConstructionOfSeqDatasetPropsData,
    IConstructionOfSeqDatasetPropsFunctions,
} from '../props/IConstructionOfSeqDatasetProps';
import { Container, Col, Row, Form, FormGroup, Label, Input } from 'reactstrap';
import HelpTooltip from '../../../commons/HelpTooltip';

type IProps = IConstructionOfSeqDatasetPropsData &
    IConstructionOfSeqDatasetPropsFunctions & { history: any };

export default class constructionOfSeqDatasetComponent extends React.Component<IProps> {
    infoRef = React.createRef<HTMLFormElement>();

    /*---------------------------------------------------------------------------------------------------------------------------------- */
    render() {
        return (
            <div style={{ marginBottom: '1em' }}>
                <Box title='CONSTRUCTION OF SEQUENCE DATASET'>
                    <Form>
                        <Container>
                            <Row>

                                <Col>
                                    <Row>
                                        <Col>
                                            <Label style={{ color: '#09A0A8' }}>
                                                BLAST E-value:
                                                <HelpTooltip>
                                                    The significance threshold for reporting results of
                                                    sequence database search. The Expectation value
                                                    (E-value) describes the number of hits one can expect
                                                    to see just by chance when searching a database of a
                                                    particular size. The lesser the E-value, or the closer
                                                    it is to zero, the more significant the match is. All
                                                    identified sequences with the E-value less than or
                                                    equal to the specified value will be reported as hits.
                                                    Increasing the E-value will most probably lead to more
                                                    hits, but their similarity to the query sequence will
                                                    be lower.
                                                </HelpTooltip>
                                            </Label>
                                        </Col>
                                        <form id='ll-input-info' ref={this.infoRef}>
                                            <div className='form-group'>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    id='blast_e_text'
                                                    name='grp1'
                                                    style={{ width: '75px', height: '30px' }}
                                                    value={this.props.blastEvalField}
                                                    onChange={(evt) =>
                                                        this.props.changeblastEvalField(
                                                            evt.target.value
                                                        )
                                                    }
                                                    required
                                                />
                                            </div>
                                        </form>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Label
                                                htmlFor='maxNumSeqField'
                                                style={{ color: '#09A0A8' }}>
                                                Max. number of sequences:
                                                <HelpTooltip>
                                                    The maximum number of sequences in the sequence
                                                    dataset. The sequence dataset is used for the
                                                    estimation of mutability of individual protein
                                                    positions, analysis of correlated positions and
                                                    identification of consensus residues. Replace the
                                                    default value with 1000000 if you want to use all
                                                    identified homologs (beware that calculation using
                                                    many sequences may take a very long time).
                                                </HelpTooltip>
                                            </Label>
                                        </Col>
                                        <form id='ll-input-info' ref={this.infoRef}>
                                            <div className='form-group'>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    id='max_num_seq'
                                                    style={{ width: '75px', height: '30px' }}
                                                    value={this.props.maxNumSeqField}
                                                    onChange={(evt) =>
                                                        this.props.changemaxNumSeqField(
                                                            evt.target.value
                                                        )
                                                    }
                                                    required
                                                />
                                            </div>
                                        </form>
                                    </Row>
                                </Col>

                                <Col>
                                    <Row>
                                        <Col>
                                            <Label
                                                htmlFor='minIdentityFieldSP'
                                                style={{ color: '#09A0A8', paddingLeft: '4px' }}>
                                                Minimal identity (%):
                                                <HelpTooltip>
                                                    All sequence homologs having sequence identity with
                                                    the query protein less than the specified value will
                                                    be excluded from the dataset.
                                                </HelpTooltip>
                                            </Label>
                                        </Col>
                                        <form id='ll-input-info' ref={this.infoRef}>
                                            <div className='form-group'>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    id='min_identity'
                                                    style={{ width: '75px', height: '30px' }}
                                                    value={this.props.minIdentityField}
                                                    onChange={(evt) =>
                                                        this.props.changeminIdentityField(
                                                            evt.target.value
                                                        )
                                                    }
                                                    required
                                                />
                                            </div>
                                        </form>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Label
                                                htmlFor='maxIdentityField'
                                                style={{ color: '#09A0A8' }}>
                                                Maximal identity (%):
                                                <HelpTooltip>
                                                    All sequence homologs having sequence identity with
                                                    the query protein greater than the specified value be
                                                    excluded from the dataset.
                                                </HelpTooltip>
                                            </Label>
                                        </Col>
                                        <form id='ll-input-info' ref={this.infoRef}>
                                            <div className='form-group'>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    id='max_identity'
                                                    style={{ width: '75px', height: '30px' }}
                                                    value={this.props.maxIdentityField}
                                                    onChange={(evt) =>
                                                        this.props.changemaxIdentityField(
                                                            evt.target.value
                                                        )
                                                    }
                                                    required
                                                />
                                            </div>
                                        </form>
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </Form>
                </Box>
            </div>
        );
    }
}
